import { Service } from "../../../service.js";
import { env } from "../../../env.js";

class TotalizadorService extends Service {
  constructor() {
    super();

    this.url = env.url + "totalizador";
  }

  async get(objetoQueryString) {
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoQueryString);
    return super.get(this.url + queryString);
  }

  async getDesempenhoEntregas(objetoQueryString) {

    try {
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoQueryString);

      return super.get(this.url + "/dashboard-desempenho-entregas" + queryString);

    } catch(e) {
      console.warn(e)
    }
    
  }

  async getAtendimentosEmAtraso(objetoQueryString) {

    try {
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoQueryString);

      return super.get(this.url + "/atendimentos-em-atraso" + queryString);

    } catch(e) {
      console.warn(e)
    }
    
  }
}

export const service = new TotalizadorService();

